<template>
  <section class="hero">
    <!-- 左侧内容 -->
    <div class="left-content">
      <div class="tag">✦ CRYPTO RECOVERY // RECOVERY_ACTIVE</div>
      <h1>Restoring Access to <br><span class="highlight">Lost Assets</span></h1>
      <p>Fraud Counsel Department is a government-certified crypto recovery firm specializing in helping victims recover
        lost or stolen cryptocurrency. We combine blockchain forensics, on-chain analysis, and investigative expertise
        to trace funds and support recovery efforts with complete transparency.</p>
      <button class="hero-btn">Start Recovery →</button>
    </div>

    <!-- 右侧视觉与终端 -->
    <div class="right-content">
      <!-- 追踪雷达省略，保持原样 -->
      <div class="tracking-visual">
        <div class="radar"></div>
        <div class="radar-text">RECOVERY TRACKING</div>
      </div>

      <div class="terminal">
        <div class="term-header">
          <div class="dots"><span class="red"></span><span class="yellow"></span><span class="green"></span></div>
          <span class="title">recovery@fraudcounsel:~</span>
        </div>
        <div class="term-body">
          <p v-for="(line, idx) in terminalLines" :key="idx">
            <span class="prompt">$</span> {{ line }}
          </p>
          <p v-if="terminalLines.length > 0">
            <span class="prompt">$</span> <span class="cursor">▊</span>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      terminalLines: [],
      allTerminalLines: [
        "initiating crypto recovery protocol...",
        "blockchain forensics initialized [OK]",
        "fund tracking in progress...",
        "case integrity: ver"
      ],
      lineIndex: 0,
      charIndex: 0,
      timer: null
    };
  },
  mounted() {
    this.typeNextLine();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    typeNextLine() {
      // 所有行输出完毕，停顿2秒后清空重新开始
      if (this.lineIndex >= this.allTerminalLines.length) {
        this.timer = setTimeout(() => {
          this.terminalLines = [];
          this.lineIndex = 0;
          this.charIndex = 0;
          this.typeNextLine();
        }, 2000);
        return;
      }

      const currentLine = this.allTerminalLines[this.lineIndex];
      this.timer = setTimeout(() => {
        this.charIndex++;
        // 更新当前正在打字的那一行
        this.$set(this.terminalLines, this.lineIndex, currentLine.substring(0, this.charIndex));

        if (this.charIndex < currentLine.length) {
          this.typeNextLine();
        } else {
          // 当前行完成，进入下一行
          this.lineIndex++;
          this.charIndex = 0;
          this.typeNextLine();
        }
      }, 80); // 每个字 80ms，可调整快慢
    }
  }
}
</script>

<style scoped>
.hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 80px 5% 60px;
  gap: 50px;
}

.left-content {
  flex: 1;
}

.tag {
  display: inline-block;
  border: 1px solid #3e4c72;
  border-radius: 50px;
  padding: 8px 20px;
  color: #a0b3cc;
  font-size: 0.85rem;
  margin-bottom: 30px;
  letter-spacing: 1px;
}

h1 {
  font-size: 3.2rem;
  margin: 0 0 20px;
  line-height: 1.1;
}

.highlight {
  color: #2ee6a8;
}

p {
  color: #a0b3cc;
  line-height: 1.8;
  font-size: 1.1rem;
  max-width: 600px;
  margin-bottom: 40px;
}

.hero-btn {
  background: linear-gradient(90deg, #5b6cff, #2ee6a8);
  border: none;
  color: #fff;
  padding: 16px 32px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 0 20px rgba(91, 108, 255, 0.6);
}

.right-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

/* 追踪雷达动画模拟 */
.tracking-visual {
  position: relative;
  height: 150px;
  border-radius: 12px;
  background: radial-gradient(circle at center, rgba(91, 108, 255, 0.3) 0%, transparent 70%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.radar {
  width: 120px;
  height: 120px;
  border: 1px solid rgba(91, 108, 255, 0.5);
  border-radius: 50%;
  position: relative;
  animation: pulse 3s infinite;
}

.radar::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(91, 108, 255, 0.3);
  border-radius: 50%;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }

  50% {
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
}

.radar-text {
  position: absolute;
  bottom: 10px;
  font-weight: bold;
  letter-spacing: 4px;
  color: #a0b3cc;
}

/* 终端样式 */
.terminal {
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid #333;
  border-radius: 8px;
  overflow: hidden;
  font-family: 'Courier New', monospace;
}

.term-header {
  background: #111;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #333;
}

.dots {
  display: flex;
  gap: 6px;
}

.red {
  width: 10px;
  height: 10px;
  background: #ff5f56;
  border-radius: 50%;
}

.yellow {
  width: 10px;
  height: 10px;
  background: #ffbd2e;
  border-radius: 50%;
}

.green {
  width: 10px;
  height: 10px;
  background: #27c93f;
  border-radius: 50%;
}

.title {
  color: #aaa;
  font-size: 0.9rem;
}

.term-body {
  padding: 20px;
  font-size: 1.1rem;
  color: #fff;
}

.term-body p {
  margin: 0 0 8px;
  color: #fff;
  font-size: 1rem;
  font-family: monospace;
}

.prompt {
  color: #2ee6a8;
  margin-right: 10px;
}

.cursor {
  display: inline-block;
  background: #fff;
  width: 8px;
  height: 16px;
  margin-left: 2px;
  animation: blink 1s infinite;
  vertical-align: middle;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

@media (max-width: 900px) {
  .hero {
    flex-direction: column;
    padding-top: 40px;
  }

  .left-content {
    order: 2;
  }

  .right-content {
    order: 1;
    width: 100%;
  }

  h1 {
    font-size: 2.5rem;
  }

  .tracking-visual {
    height: 120px;
  }
}
</style>